import React, {useContext} from "react"
import Typography from "../../reusable/Typography/Typography"
import LayoutContext from "../../../context/LayoutContext"
import {useRouter} from "next/router"

type Props = {
    isLeftAligned?: boolean
    title: string
    description:string
    styles1?:object
    styles2?:object
}
function ReusableTitleDescription({title, description, isLeftAligned, styles1, styles2}:Props) {
	const {isMobile} = useContext(LayoutContext)
	const router = useRouter()
	const {brand} = router.query
	const isShowRoomPage = brand === "mybikeplan"
	return (
		<div style={{gap: "40px", marginTop: isMobile || isShowRoomPage ? "55px" : "100px"}}
			className="text-white d-flex align-items-center justify-content-start flex-column">
			<Typography variant="bodyLgBlack"
				style={{...styles1, fontSize: isMobile ? "40px" : "64px", maxWidth: 600, width: "100%", zIndex: "20", lineHeight: isMobile ? "48px" : "76.8px", color: "#fff", textAlign: isLeftAligned ? "left" : "center"}} > { title}
			</Typography>
			{isShowRoomPage ?
				<div className="mt-md-3 row flex-column align-items-center gy-5">
					<div className="col-md-12"
					>
						<iframe
							width="760"
							height="400"
							src="https://www.youtube.com/embed/hMaDxhPJ0BQ"
							title="YouTube video player"
							frameBorder="0"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
							allowFullScreen
							className="showroom-video"
							style={{borderRadius: "24px"}}
						></iframe>
					</div>
					<div className="col-md-12 text-center"
						style={{maxWidth: 590, width: "100%"}}>
						<Typography variant="bodySm"
							style={{...styles2, fontSize: "16px", lineHeight: "24px", zIndex: "20", color: "#fff"}} >
							{ description}
						</Typography>
					</div>
				</div> :
				<Typography variant="bodySm"
					style={{...styles2, fontSize: "16px", lineHeight: "24px", maxWidth: 600, width: "100%", zIndex: "20", color: "#fff", textAlign: isLeftAligned ? "left" : "center"}} >
					{ description}
				</Typography>
			}
		</div>
	)
}

export default ReusableTitleDescription
